import React from "react";
import { BsXCircle } from "react-icons/bs";
import { FaHourglassEnd } from "react-icons/fa6";

export default function ContactHistoryCell({ getValue, table, cell,  }) {
	const hiddenColumns = table.options.meta?.hiddenColumns;
	const columnId = cell.column.id;
	const isHidden = hiddenColumns && hiddenColumns.find((item) => item.id === columnId);

	if (isHidden) return <div className="ignore"></div>;
	
	const status = getValue()?.status ?? "";
	switch (status) {
		case "error":
			return <BsXCircle color="#FB2E5F" />;
		case "clock":
			return (
				<div>
					<FaHourglassEnd />/{getValue()?.allCalls}
				</div>
			);
		default:
			return (
				<div>
					{getValue()?.calls}/{getValue()?.allCalls}
				</div>
			);
	}
}
